import Main from '@/components/main/Main';
// 支付模块的路由
export default [
  {
    name: 'dmp_ad_main',
    path: '/dmp/ad/main',
    component: Main,
    redirect: '/dmpadvertiser/plan',
    meta: {
      showInMenu: true,
      showAlways: true, // 表示一定要展示子菜单
      title: '投放',
      icon: 'ios-apps'
    },
    children: [
      {
        name: 'group',
        path: '/dmpadvertiser/group',
        component: () =>
          import('@/emc-dmp/views/dmpadvertiser/group'),
        meta: {
          showInMenu: true,
          path: '/dmpadvertiser/group',
          title: '广告组',
          icon: 'logo-apple'
        }
      },
      {
        name: 'adgroup',
        path: '/dmpadvertiser/adGroup',
        component: () =>
          import('@/emc-dmp/views/dmpadvertiser/adGroup'),
        meta: {
          showInMenu: false,
          path: '/dmpadvertiser/adGroup',
          title: '添加广告组',
          icon: 'logo-apple'
        }
      },
      {
        name: 'plan',
        path: '/dmpadvertiser/plan',
        component: () =>
          import('@/emc-dmp/views/dmpadvertiser/plan'),
        meta: {
          showInMenu: true,
          path: '/dmpadvertiser/plan',
          title: '广告计划',
          icon: 'logo-apple'
        }
      },
      {
        name: 'adplan',
        path: '/dmpadvertiser/adPlan',
        component: () =>
          import('@/emc-dmp/views/dmpadvertiser/adPlan'),
        meta: {
          showInMenu: false,
          path: '/dmpadvertiser/adPlan',
          title: '添加广告计划',
          icon: 'logo-apple'
        }
      },
      {
        name: 'adidea',
        path: '/dmpadvertiser/adIdea',
        component: () =>
          import('@/emc-dmp/views/dmpadvertiser/adIdea'),
        meta: {
          showInMenu: true,
          path: '/dmpadvertiser/adIdea',
          title: '广告创意',
          icon: 'logo-apple'
        }
      },
      {
        name: 'dmp_ad',
        path: '/dmp/ad',
        component: () => import('@/emc-dmp/views/dmpad'),
        meta: {
          showInMenu: false,
          path: '/dmp/ad',
          title: '广告投放',
          icon: 'logo-apple'
        }
      },
      {
        name: 'dmp_ad_add',
        path: '/dmp/ad/add',
        component: () => import('@/emc-dmp/views/dmpad/EditPage'),
        meta: {
          showInMenu: false
        }
      },
      {
        name: 'dmp_audience',
        path: '/dmp/audience',
        component: () => import('@/emc-dmp/views/custom-audience'),
        meta: {
          showInMenu: true,
          path: '/dmp/audience',
          title: '自定义人群',
          icon: 'logo-apple'
        }
      },
      {
        name: 'dmp_convert',
        path: '/dmp/convert',
        component: () => import('@/emc-dmp/views/dmpconvert'),
        meta: {
          showInMenu: true,
          path: '/dmp/convert',
          title: '转化配置',
          icon: 'logo-apple'
        }
      },
      {
        name: 'dmp_convert_add',
        path: '/dmp/convert/add',
        component: () => import('@/emc-dmp/views/dmpconvert/EditPage'),
        meta: {
          showInMenu: false
        }
      }
    ]
  }
];
